/**
 * WeedCategories — мини-справочник «Категории сорняков».
 * Тонкий wrapper над `ReferenceMiniCatalog` — тот же компонент, что у
 * категорий болезней и вредителей. DELETE-guard через usage_count.
 */
import { PlatformAdminLayout } from '@/layouts/PlatformAdminLayout';
import { ReferenceMiniCatalog } from '@/components/reference/ReferenceMiniCatalog';
import {
  useCreateWeedCategory,
  useDeleteWeedCategory,
  useUpdateWeedCategory,
  useWeedCategories,
} from './hooks/useCatalogQueries';
import { toast } from '@/lib/toast';

function plural(n: number): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m100 >= 11 && m100 <= 14) return 'сорняков';
  if (m10 === 1) return 'сорняк';
  if (m10 >= 2 && m10 <= 4) return 'сорняка';
  return 'сорняков';
}

export function PlatformAdminWeedCategoriesPage() {
  const q = useWeedCategories();
  const createMut = useCreateWeedCategory();
  const updateMut = useUpdateWeedCategory();
  const deleteMut = useDeleteWeedCategory();

  const items = q.data?.items ?? [];

  return (
    <PlatformAdminLayout>
      <ReferenceMiniCatalog
        title="Категории сорняков"
        subtitle={`Мини-справочник · ${items.length} записей`}
        createLabel="Добавить категорию"
        usageBadgeUnit={plural}
        guardMessage="Используется сорняками — нельзя удалить"
        items={items}
        isLoading={q.isLoading}
        onCreate={async (payload) => {
          await createMut.mutateAsync(payload);
          toast.success('Категория создана');
        }}
        onUpdate={async (id, payload) => {
          await updateMut.mutateAsync({ id, payload });
          toast.success('Категория обновлена');
        }}
        onDelete={async (id) => {
          // Отказ ловит и показывает сам ReferenceMiniCatalog (AK-574).
          await deleteMut.mutateAsync(id);
          toast.success('Категория удалена');
        }}
      />
      <p className="mt-3 text-[11px] text-muted-foreground">
        Изменения сразу доступны в select формы сорняка. Код — технический ключ
        (по нему работают фильтры и подбор препаратов), меняйте только название.
        EN-перевод отложен — ведём только RU.
      </p>
    </PlatformAdminLayout>
  );
}

export default PlatformAdminWeedCategoriesPage;
